import { createGlobalStyle } from 'styled-components'

export const ConfirmModalGlobalStyle = createGlobalStyle`
  .news-confirm-modal-wrapper {
    font-family: 'Inter', Noto Sans Display, sans-serif !important;

    .ant-modal {
      max-width: calc(100vw - 32px);
      font-family: 'Inter', Noto Sans Display, sans-serif !important;
    }

    .ant-modal-content {
      border-radius: 16px !important;
      overflow: hidden !important;
      box-shadow: 0 20px 40px -8px rgba(15, 23, 42, 0.2) !important;
      border: 1px solid #eef2f6 !important;
      background: #ffffff !important;
      padding: 0 !important;
      font-family: 'Inter', Noto Sans Display, sans-serif !important;
    }

    .ant-modal-header {
      border: none !important;
      border-bottom: 1px solid #f1f5f9 !important;
      padding: 20px 24px !important;
      background: #ffffff !important;
    }

    .ant-modal-title {
      color: #0f172a !important;
      font-family: 'Inter', Noto Sans Display, sans-serif !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      letter-spacing: -0.01em !important;
      line-height: 24px !important;
      background: transparent !important;
    }

    .ant-modal-close {
      top: 16px !important;
      right: 18px !important;
    }

    .ant-modal-close-x {
      width: 36px !important;
      height: 36px !important;
      line-height: 36px !important;
      border-radius: 8px !important;
      transition: background 0.2s ease !important;
      color: #64748b !important;

      &:hover {
        background: #f1f5f9 !important;
        color: #0f172a !important;
      }
    }

    .ant-modal-body {
      background: #ffffff !important;
      padding: 24px 24px 16px !important;
    }

    .confirm-modal-text {
      font-size: 14.5px;
      color: #334155;
      line-height: 1.6;
      margin-bottom: 16px;
      font-weight: 500;
    }

    .confirm-modal-checkbox {
      .ant-checkbox-inner {
        border-radius: 4px !important;
        border-color: #cbd5e1 !important;
        width: 18px !important;
        height: 18px !important;
      }

      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #70aefb !important;
        border-color: #70aefb !important;
      }

      span:last-child {
        font-size: 14px;
        font-weight: 500;
        color: #1e293b;
        padding-left: 10px;
      }
    }

    .ant-modal-footer {
      border-top: 1px solid #f1f5f9 !important;
      padding: 16px 24px !important;
      background: #ffffff !important;
      display: flex !important;
      justify-content: flex-end !important;
      align-items: center !important;
      gap: 12px !important;
    }

    .confirm-btn-cancel {
      height: 40px !important;
      min-width: 90px !important;
      padding: 0 18px !important;
      border-radius: 8px !important;
      border: 1px solid #e2e8f0 !important;
      background: #ffffff !important;
      color: #475569 !important;
      font-family: 'Inter', Noto Sans Display, sans-serif !important;
      font-size: 13.5px !important;
      font-weight: 500 !important;
      transition: all 0.2s ease !important;

      &:hover,
      &:focus {
        background: #f8fafc !important;
        border-color: #cbd5e1 !important;
        color: #0f172a !important;
      }
    }

    .confirm-btn-submit {
      height: 40px !important;
      min-width: 100px !important;
      padding: 0 20px !important;
      border-radius: 8px !important;
      background-color: #70aefb !important;
      border-color: #70aefb !important;
      color: #ffffff !important;
      font-family: 'Inter', Noto Sans Display, sans-serif !important;
      font-size: 13.5px !important;
      font-weight: 600 !important;
      box-shadow: 0 2px 6px rgba(112, 174, 251, 0.28) !important;
      transition: all 0.2s ease !important;

      &:hover,
      &:focus {
        background-color: #5b9ef8 !important;
        border-color: #5b9ef8 !important;
        box-shadow: 0 4px 12px rgba(112, 174, 251, 0.35) !important;
        transform: translateY(-1px);
      }
    }
  }
`
